<template>
  <wrs-label :label="valueItem.label" :value="model" :isHighlighted="isHighlighted" :highLightColor="highLightColor" />
</template>
<script>
  // WrsViLabel.vue
  import WrsLabel from '../WrsLabel.vue';

  export default {
    components: {
      'wrs-label': WrsLabel
    },
    props: {
      valueItem: {
        type: Object,
        default: function () {
          return {
            label: "",
            isRequired: false,
            requiredError: "",
            error: "",
            hasError: false,
            items: [],
            value: 0
          };
        },
      },
      isList: {
        type: Boolean,
        default: false
      },
      isHighlighted: {
        // type: String,
        type: Boolean,
        default: false
      },
      highLightColor: {
        type: String,
        default: "black",
      },
    },
    computed: {
      model: {
        get() {
          if (this.isList) {
            let item = this.valueItem.items.find(element => element.id == this.valueItem.value);
            if (item) {
              return item.text;
            }
            else {
              return "";
            }
          }
          else {
            return this.valueItem.value;
          }
        },
      },
    },
  }
</script>
